<style scoped lang="sass">
.upgrade-combo-dialog
  ::v-deep
    .theme_color
      color: var(--menu-primary-background-colour) !important

    .app-container
    .title
      font: normal normal bold 18px/26px Roboto
      text-align: center
      font-weight: bold
      margin: 5px 25px
    .price
      text-align: center
      font: normal normal normal 16px/21px Roboto
      margin: 10px 25px
    .content
      .logo_img
        width: 100%
    .footer
      padding: 20PX 0
      display: flex
      justify-content: space-around
      align-items: center
      border-top: 1px solid #e8e8e9
      background: #fff
      z-index: 2

      .footer_button
        width: 45%
        border-radius: 4px !important
        overflow: hidden
        font-weight: bold
        ::v-deep
        .van-button__text
          white-space: pre-wrap
</style>

<template lang="pug">
bottom-popup-dialog.upgrade-combo-dialog(
  v-model="isVisible",
  @input="handleInput",
  @changeShow="closeDialog",
  :showCloseIcon="false"
)
  template(v-slot:popup-dialog)
    .title.b {{ title }}
    .price {{ adjustPrice }}
    .content
      img.logo_img(:src="imgSrc")
    .footer
      van-button.footer_button.theme_color(size="large", @click="closeDialog") {{ t('no_thanks', 'NO THANKS') }}
      van-button.footer_button(type="primary", size="large", @click="redirect") {{ t('ok', 'OK') }}
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { getLocalizedField, t } from '@/utils/language'
import { convertPrice, formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'

@Component({
  props: {
    comboProducts: { type: Array, default: {} },
    value: { type: Boolean, default: false },
    productInfo: { type: Object, default: {} }
  },

  computed: {
    /**
     * @returns {String} 弹窗标题
     */
    title() {
      const combo = this.comboProducts?.[0]
      if (!combo) return ''
      return getLocalizedField(combo, 'title') || getLocalizedField(combo, 'displayName') || combo.title || ''
    },

    id() {
      return this.comboProducts?.[0]?.items?.[0].id ?? ''
    },

    imgSrc() {
      const product = this.comboProducts?.[0]?.items?.[0]
      return product ? (getLocalizedField(product, 'image') || product.image || '') : ''
    },
    adjustPrice() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      let priceText = ''
      let minPrice = 0
      let maxPrice = 0
      const comboPriceList = this.priceAmount(this.comboProducts?.[0]?.items?.[0])
      const currentPriceList = this.priceAmount(this.productInfo)

      if (comboPriceList.length) {
        minPrice = parseFloat(comboPriceList[0])
        maxPrice = parseFloat(comboPriceList[1]) ? parseFloat(comboPriceList[1]) : parseFloat(comboPriceList[0])
      }
      if (currentPriceList.length) {
        minPrice -= parseFloat(currentPriceList[0])
        // maxPrice -= parseFloat(currentPriceList[1]) ? parseFloat(currentPriceList[1]) : parseFloat(currentPriceList[0])
        maxPrice -= parseFloat(currentPriceList[0])
      }
      if (minPrice === maxPrice) {
        priceText = this.getPriceText(minPrice)
      } else {
        const text1 = this.getPriceText(minPrice)
        const text2 = this.getPriceText(maxPrice)
        if (minPrice < maxPrice) {
          priceText = text1
          // priceText = `${text1} - ${text2}`
        } else {
          priceText = text2
          // priceText = `${text2} - ${text1}`
        }
      }
      return priceText
    },

    isVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
})

class UpgradeComboDialog extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  mounted() {
  }

  handleInput(val) {
    this.$emit('input', val)
  }

  getPriceText(price) {
    const symbol = getCurrencySymbol()
    const position = getSymbolPosition()
    const convertedPrice = formatDecimalNumber(convertPrice(Math.abs(price)))
    const sign = price < 0 ? '-' : '+'
    if (position === 'after') {
      return `${sign}${convertedPrice} ${symbol}`
    }
    return `${sign}${symbol}${convertedPrice}`
  }

  priceAmount(product) {
    const price = parseFloat(product?.price) ?? 0
    const priceList = []
    const enableMutipleSize = product?.sizeSettings?.mutipleSize
    if (enableMutipleSize) {
      const ls = product.sizeSettings.settings.map(item => parseFloat(item.price))
      if (product.sizeSettings.settings.length === 1) {
        priceList.push(Math.min(...ls))
      } else {
        priceList.push(Math.min(...ls))
        priceList.push(Math.max(...ls))
      }
    } else {
      if (!this._.isUndefined(price)) priceList.push(price)
    }
    if (!priceList.length) priceList.push(0)
    return priceList
  }

  // 关闭弹窗
  closeDialog() {
    this.$emit('confirm', this.productInfo)
    this.$emit('input', false)
  }

  // OK按钮点击处理
  redirect() {
    // 向父组件发送confirm事件，传递comboProducts数据
    this.$emit('confirm', { ...this.productInfo, fromProductId: this.productInfo.id, id: this.id })
    // 关闭弹窗
    this.$emit('input', false)
  }
}

export default UpgradeComboDialog
</script>
